import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import type { ExtendedBuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { proContactsComponent } from '@nodeTypeConfig/helpers/editComponents/proContactsComponent';
import { proLinks } from '@nodeTypeConfig/helpers/editComponents/proLinksAndMenuReferences';
import { proThumbnailComponent } from '@nodeTypeConfig/helpers/editComponents/proThumbnailComponent';
import { proWebFacetPlaceHolderComponent } from '@nodeTypeConfig/helpers/editComponents/proWebFacetComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { proDefaultBuildingBlocks } from '../../helpers/buildingBlocks/proDefaultBuildingBlocks';
import { extendsSection } from '../../helpers/genericConfigHelpers';
import { proTileDefaultValidionRules } from '../proGenericConfigProps';
// Extends SECTION => A SECTION inside a Pro Theme and webConfig MINI_DATABASE_ITEM becomes a PRO_DATABASE_ITEM
const PRO_BLOG_ITEM: ExtendedBuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  validationRules: proTileDefaultValidionRules,
  information: {
    definiteArticle: true,
    description: 'A Blog Item, can only appear as child of a blog',
    single: 'Blog item',
    plural: 'Blog Items',
    icon: require('../../../../../img/icons/webpage.svg'),
  },
  ...extendsSection,
  isCollapsedByDefault: true,
  buildingBlocks: proDefaultBuildingBlocks,
  edit: [
    titleComponent,
    {
      ...proThumbnailComponent,
      width: 6,
    },
    proContactsComponent,
    proLinks,
    proWebFacetPlaceHolderComponent,
  ],
  webTab: asideWebBasicConfiguration,
  confirmDelete: true,
};

export default PRO_BLOG_ITEM;
